/* eslint-disable max-len */
import React, { DetailedHTMLProps, HTMLAttributes } from 'react'

const img = `
<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 28 28">
  <defs>
    <clipPath id="clip-path">
      <rect id="Rectangle_572" data-name="Rectangle 572" width="100%" height="100%" transform="translate(0)" fill="none" stroke="currentColor" stroke-width="1"/>
    </clipPath>
  </defs>
  <g id="Group_2734" data-name="Group 2734" transform="translate(0)" clip-path="url(#clip-path)">
    <circle id="Ellipse_82" data-name="Ellipse 82" cx="11.651" cy="11.651" r="11.651" transform="translate(-4.371 12.105) rotate(-45)" fill="none" stroke="currentColor" stroke-miterlimit="10" stroke-width="1"/>
    <path id="Path_1727" data-name="Path 1727" d="M38.417,30.017a8.854,8.854,0,1,1-8.4-9.284A8.854,8.854,0,0,1,38.417,30.017Z" transform="translate(-17.469 -17.47)" fill="none" stroke="currentColor" stroke-miterlimit="10" stroke-width="1"/>
    <path id="Path_1728" data-name="Path 1728" d="M90.764,87.155l4.443,3.872a2.963,2.963,0,1,1-4.18,4.18l-3.872-4.443" transform="translate(-68.605 -68.605)" fill="none" stroke="currentColor" stroke-miterlimit="10" stroke-width="1"/>
  </g>
</svg>
`

const SearchSvg = (props: DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>): JSX.Element => {
  return <div {...props} dangerouslySetInnerHTML={{ __html: img }} />
}

export default SearchSvg
